// extracted by mini-css-extract-plugin
module.exports = {"explanations":"bl_hd","explanations__item":"bl_hf","explanations__title":"bl_hg","explanations__text":"bl_hh"};